"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ToastTrigger: function() {
        return _index.ToastTrigger;
    },
    renderToastTrigger_unstable: function() {
        return _index.renderToastTrigger_unstable;
    },
    useToastTrigger_unstable: function() {
        return _index.useToastTrigger_unstable;
    }
});
const _index = require("./components/ToastTrigger/index");
